import { useContext } from 'react';
import './bottom-cart.css';
import { Link } from 'react-router-dom';
import { cartContext } from '../../App';

export default function BottomCart() {

    const { CartItem, extraData } = useContext(cartContext);

    const orderValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price) * item.qty, 0);
    
    const freeDelShow = orderValue >= extraData.data.minOrderValueFee ? true : false

    return (
        <>
            {CartItem.length > 0 && (
                <div className="bottom-cart">
                    {freeDelShow && (
                        <div className="bottom-cart-high">
                            <p className="bottom-cart-free-delivery-text">
                                🎉 Free delivery unlocked
                            </p>
                        </div>
                    )}

                    <div className="bottom-cart-low">
                        <div className="bottom-cart-summary">
                            <p className="items-no-bottom-cart">
                                {CartItem.length} {CartItem.length > 1 ? "items" : "item"}
                            </p>

                            <p className="bottom-cart-price">
                                ₹{orderValue}
                            </p>
                        </div>

                        <Link to="/cart" className="bottom-cart-link">
                            View Cart
                            <img
                                src="shopping-cart.png"
                                alt="cart"
                                className="bottom-cart-icon"
                            />
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
}


